// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pEXC","textarea":"styles_textarea__2AiLF"};